<!-- src/apps/secret/components/delivery/ViewLimitNotice.vue -->

<script setup lang="ts">
  /**
   * Eightpoint: tells the recipient how many more times a multi-view link can
   * be opened. Renders nothing for single-view (default) secrets.
   */
  import { useI18n } from 'vue-i18n';
  import { computed } from 'vue';

  interface Props {
    maxViews?: number | null;
    viewsRemaining?: number | null;
  }

  const props = defineProps<Props>();
  const { t } = useI18n();

  const visible = computed(() => (props.maxViews ?? 1) > 1 && props.viewsRemaining != null);
  const message = computed(() => {
    const remaining = props.viewsRemaining ?? 0;
    if (remaining <= 0) return t('web.secrets.delivery.views_left_none');
    if (remaining === 1) return t('web.secrets.delivery.views_left_one');
    return t('web.secrets.delivery.views_left_many', { count: remaining });
  });
</script>

<template>
  <p
    v-if="visible"
    class="mb-4 rounded-md border-l-4 border-sky-400 bg-sky-50 p-3 text-sm text-sky-800
      dark:border-sky-500 dark:bg-sky-900/30 dark:text-sky-100"
    role="status"
    data-testid="view-limit-notice">
    {{ message }}
  </p>
</template>
